export class ShoppingCartModal {
  BeneficiaryName= '';
  BeneficiaryNickName = '';
  // Amount
  TransferAmount = 0.0;
  TotalAmount = 0.0;
  AmountLocal=0.0;
  // Country
  CountryCodeFrom = '';
  CountryCodeTo = '';
  // Currency
  CurrencyCodeFrom = '';
  CurrencyCodeTo = '';
  DeliveryMethod = '';
  Commission = 0.0;
  Rate = 0.0;
  RateExpired = 0.0;
  FundingId = '';
  StoreId = '';
  StoreName = '';
  ItemAddOn = '';
  ItemCount = '';
  MarketingBalance = 0;
  PayingAgent = '';
  PayingAgentId = '';
  PayingAgentLocation = '';
  PayingAgentLocationId = '';
  ProgramId = '';
  BankId =  '';
  BankName = '';
  AccountNumber = '';
  BankAccountType = '';
  PickupType = '';
  PickupCenterImage ='';
  PayingAgentName='';
  DebitCardNumber: '';
  DebitCardFriendlyName='';
  CustomerPaymentMethod;
  isSuperSendLabel=false;
}



// WEBPACK FOOTER //
// ./src/app/dash-board/shoppingcart/shoppingcartsummary/shoppingCartModal.ts